import { create } from 'zustand';
import { devtools } from 'zustand/middleware';
import { ParkingSession } from '../utils/utilTypes';

type StateType = {
  ongoingSession: ParkingSession | null;
  setOngoingSession: (session: ParkingSession) => void;
  clearOngoingSession: () => void;
};

export const useSessionsSlice = create<StateType>()(
  devtools(
    (set) => ({
      ongoingSession: null,
      setOngoingSession: (session) =>
        set({ ongoingSession: session }, false, 'setOngoingSession'),
      clearOngoingSession: () =>
        set({ ongoingSession: null }, false, 'clearOngoingSession'),
    }),
    { name: 'Sessions Store' }
  )
);
